<template>
  <div class="container">
    <div class="home"><router-link to="/">Zurück</router-link></div>
    <div class="row impressum">
      <h2 class="impressum_header">Impressum</h2>
      <p>
        Die Portal musiconn ist ein Gemeinschaftsprojekt der Bayerischen
        Staatsbibliothek und der Sächsische Landesbibliothek – Staats- und
        Universitätsbibliothek Dresden. Die Domain ist Eigentum der Bayerischen
        Staatsbibliothek München. Das Hosting erfolgt über einen Server der
        Bayerischen Staatsbibliothek. Für sämtliche hier veröffentlichten
        Inhalte gilt das
        <a href="http://www.bsb-muenchen.de/impressum" target="_blank"
          >Impressum der Bayerischen Staatsbibliothek</a
        >.
      </p>
      <p>
        Im Folgenden informieren wir Sie über Art, Umfang und Zweck der Erhebung
        und Verwendung personenbezogener Daten im Rahmen dieses Internetangebots
        der Bayerischen Staatsbibliothek (BSB). Diese Informationen sind
        jederzeit
        <a
          href="https://www.bsb-muenchen.de/datenschutzerklaerung/"
          target="_blank"
          >hier</a
        >
        abrufbar.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Masthead",
};
</script>
<style scoped>
.home {
  font-size: 20px;
  text-align: start;
  margin: 10px;
}
.container {
  height: 65vh;
}
.impressum {
  text-align: start;
  margin-top: 110px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 0px;
}
.impressum_header {
  color: #ff6600;
  font-weight: 400;
}
a {
  color: #ff6600;
}
@media (max-width: 1200px) {
  .container {
    height: 70vh;
  }
}
@media (max-width: 768px) {
  .container {
    height: 65vh;
  }
  .impressum {
    font-size: 15px;
  }
}
@media (max-width: 600px) {
  .home {
    margin-left: 25px;
    margin-top: 25px;
  }
  .container {
    height: 60vh;
  }
  .impressum {
    margin-left: 25px;
    margin-right: 25px;
    font-size: 14px;
  }
}
@media (max-width: 363px) {
  .home {
    margin-left: 15px;
  }
  .container {
    height: 65vh;
  }

  .impressum {
    margin-top: 70px;
    margin-left: 15px;
    margin-right: 15px;
    font-size: 13px;
  }
}
@media (max-width: 288px) {
  .container {
    height: 70vh;
  }
}
</style>
